import { createAction } from "@reduxjs/toolkit";
export var ActionTypes;
(function (ActionTypes) {
    ActionTypes["fetch"] = "brandedFares/fetch";
    ActionTypes["fetchSuccess"] = "brandedFares/fetchSuccess";
    ActionTypes["fetchError"] = "brandedFares/fetchError";
    ActionTypes["reset"] = "brandedFares/reset";
    ActionTypes["selectFare"] = "brandedFares/selectFare";
})(ActionTypes || (ActionTypes = {}));
export const actions = {
    fetch: createAction(ActionTypes.fetch, (baseOfferToken) => ({
        payload: { baseOfferToken }
    })),
    fetchSuccess: createAction(ActionTypes.fetchSuccess, (brandedFaresOffers, baseOfferToken, comparisonTable, comparisonTableCompact) => ({
        payload: { brandedFaresOffers, baseOfferToken, comparisonTable, comparisonTableCompact }
    })),
    fetchError: createAction(ActionTypes.fetchError, (error, baseOfferToken) => ({
        payload: { error, baseOfferToken }
    })),
    selectFare: createAction(ActionTypes.selectFare, (fareToken) => ({
        payload: { fareToken }
    })),
    reset: createAction(ActionTypes.reset, () => ({
        payload: {}
    }))
};
